import Gamepad2 from 'lucide-react/dist/esm/icons/gamepad-2';
import Headphones from 'lucide-react/dist/esm/icons/headphones';
import Keyboard from 'lucide-react/dist/esm/icons/keyboard';
import Laptop from 'lucide-react/dist/esm/icons/laptop';
import Monitor from 'lucide-react/dist/esm/icons/monitor';
import Smartphone from 'lucide-react/dist/esm/icons/smartphone';
import Tv from 'lucide-react/dist/esm/icons/tv';
import Zap from 'lucide-react/dist/esm/icons/zap';
import { HERO_SECTION_CATEGORIES, itemsHrefForTag } from '@/lib/featured-categories';
import { FeaturedCategorySection } from './featured-category-section';
import { HomeHeroSkeleton } from './home-hero-skeleton';
import { PriceDropsSection } from './price-drops-section';

const CATEGORY_ICONS: Record<string, React.ReactNode> = {
  Smartphone: <Smartphone className="h-5 w-5 text-muted-foreground" />,
  Laptop: <Laptop className="h-5 w-5 text-muted-foreground" />,
  Tv: <Tv className="h-5 w-5 text-muted-foreground" />,
  Headphones: <Headphones className="h-5 w-5 text-muted-foreground" />,
  Gamepad2: <Gamepad2 className="h-5 w-5 text-muted-foreground" />,
  Monitor: <Monitor className="h-5 w-5 text-muted-foreground" />,
  Keyboard: <Keyboard className="h-5 w-5 text-muted-foreground" />,
  Zap: <Zap className="h-5 w-5 text-muted-foreground" />,
};

export function HomePageSkeleton() {
  return (
    <div className="flex flex-col gap-4 md:gap-6 pb-8">
      <HomeHeroSkeleton />

      <PriceDropsSection loading />

      {HERO_SECTION_CATEGORIES.map((cat) => (
        <FeaturedCategorySection
          key={cat.tagId}
          title={cat.label()}
          icon={CATEGORY_ICONS[cat.iconName]}
          items={null}
          viewAllHref={itemsHrefForTag(cat.tagId)}
          loading
        />
      ))}
    </div>
  );
}
